import { ensurePostHog } from "@/lib/analytics/posthog";

void ensurePostHog();
